import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 pb-12 pt-6"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-5xl" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_4 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_7 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_8 = { class: "text-sm text-red-500 p-error" }
const _hoisted_9 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_10 = { class: "text-sm text-red-500 p-error" }
const _hoisted_11 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_12 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_13 = { class: "text-sm text-red-500 p-error" }
const _hoisted_14 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_15 = { class: "text-sm text-red-500 p-error" }
const _hoisted_16 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_17 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_20 = { class: "text-sm text-red-500 p-error" }
const _hoisted_21 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_22 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_23 = { class: "text-sm text-red-500 p-error" }
const _hoisted_24 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_25 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_26 = { class: "text-sm text-red-500 p-error" }
const _hoisted_27 = {
  key: 0,
  class: "w-full px-2 md:w-1/3"
}
const _hoisted_28 = { class: "text-sm text-red-500 p-error" }
const _hoisted_29 = {
  key: 1,
  class: "w-full px-2 md:w-1/3"
}
const _hoisted_30 = { class: "text-sm text-red-500 p-error" }
const _hoisted_31 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_32 = { class: "text-sm text-red-500 p-error" }
const _hoisted_33 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_34 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_35 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_36 = { class: "text-sm text-red-500 p-error" }
const _hoisted_37 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_38 = { class: "text-sm text-red-500 p-error" }
const _hoisted_39 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_40 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_41 = { class: "text-sm text-red-500 p-error" }
const _hoisted_42 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_43 = { class: "text-sm text-red-500 p-error" }
const _hoisted_44 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_45 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_46 = { class: "text-sm text-red-500 p-error" }
const _hoisted_47 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_48 = { class: "text-sm text-red-500 p-error" }
const _hoisted_49 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_50 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_51 = { class: "text-sm text-red-500 p-error" }
const _hoisted_52 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_53 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_54 = { class: "text-sm text-red-500 p-error" }
const _hoisted_55 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_56 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_57 = { class: "text-sm text-red-500 p-error" }
const _hoisted_58 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_59 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_60 = { class: "text-sm text-red-500 p-error" }
const _hoisted_61 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_62 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_63 = { class: "flex flex-col align-items-center" }
const _hoisted_64 = { class: "text-xs text-wrap" }
const _hoisted_65 = { class: "text-sm text-red-500 p-error" }
const _hoisted_66 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_67 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_68 = { class: "text-sm text-red-500 p-error" }
const _hoisted_69 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_70 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_71 = { class: "text-sm text-red-500 p-error" }
const _hoisted_72 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_73 = { class: "pt-2 pb-2 px-2" }
const _hoisted_74 = { class: "flex items-center" }
const _hoisted_75 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_76 = ["disabled"]
const _hoisted_77 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_78 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[58] || (_cache[58] = _createElementVNode("h1", { class: "font-bold text-gray-800 mb-0 text-2xl text-center pt-5" }, " ACREDITARME ", -1)),
            _cache[59] || (_cache[59] = _createElementVNode("h1", { class: "text-gray-800 mb-4 text-2xl text-center pt-2 pb-5" }, " Por favor complete el formulario en su totalidad ", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block mb-1" }, "DNI / Pasaporte", -1)),
                _createVNode(_component_Field, {
                  name: "dni",
                  modelValue: _ctx.formData.dni,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "numeric",
                      onBlur: _ctx.validarDni,
                      placeholder: "Documento / Pasaporte",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["onBlur", "class"]),
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_ErrorMessage, { name: "dni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                _cache[29] || (_cache[29] = _createElementVNode("small", null, "• La organización informa que es obligatorio presentar el DNI o Pasaporte consignados en este formulario al momento de acceder a CAPER SHOW", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Nombre",
                      readonly: _ctx.soloLectura,
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["readonly", "class"]),
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Apellido",
                      readonly: _ctx.soloLectura ,
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["readonly", "class"]),
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block mb-1" }, "Email", -1)),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Email",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block mb-1" }, "Reingrese su email", -1)),
                _createVNode(_component_Field, {
                  name: "mailConfirmacion",
                  modelValue: _ctx.formData.mailConfirmacion,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.mailConfirmacion) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Reingrese su email",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "mailConfirmacion" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block mb-1" }, "Empresa / Institución", -1)),
                _createVNode(_component_Field, {
                  name: "empresa",
                  modelValue: _ctx.formData.empresa,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.empresa) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Empresa / Institución",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "empresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "block mb-1" }, "Cargo", -1)),
                _createVNode(_component_Field, {
                  name: "cargo",
                  modelValue: _ctx.formData.cargo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.cargo) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Cargo",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_ErrorMessage, { name: "cargo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block mb-1" }, "Web Site (opcional)", -1)),
                _createVNode(_component_Field, {
                  name: "website",
                  modelValue: _ctx.formData.website,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.website) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Web site",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_ErrorMessage, { name: "website" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block mb-1" }, "Pais", -1)),
                _createVNode(_component_Field, {
                  name: "pais",
                  modelValue: _ctx.formData.pais,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.pais) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione el pais",
                      options: _ctx.paises,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_26, [
                      _createVNode(_component_ErrorMessage, { name: "pais" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.formData.pais.id == '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "block mb-1" }, "Provincia", -1)),
                    _createVNode(_component_Field, {
                      name: "provincia",
                      modelValue: _ctx.formData.provincia,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.provincia) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                        _createVNode(_component_Dropdown, {
                          onBlur: handleBlur,
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: "Seleccione la provincia",
                          options: _ctx.provincias,
                          optionLabel: "descripcion",
                          class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}])
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_component_ErrorMessage, { name: "provincia" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.pais.id != '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _cache[39] || (_cache[39] = _createElementVNode("label", { class: "block mb-1" }, "Provincia / Estado", -1)),
                    _createVNode(_component_Field, {
                      name: "provinciaEstado",
                      modelValue: _ctx.formData.provinciaEstado,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.provinciaEstado) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Provincia / Estado",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_30, [
                          _createVNode(_component_ErrorMessage, { name: "provinciaEstado" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_31, [
                _cache[40] || (_cache[40] = _createElementVNode("label", { class: "block mb-1" }, "Localidad", -1)),
                _createVNode(_component_Field, {
                  name: "localidad",
                  modelValue: _ctx.formData.localidad,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.localidad) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese la localidad",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_32, [
                      _createVNode(_component_ErrorMessage, { name: "localidad" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)),
                (_ctx.formData.pais !== null)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      modelValue: _ctx.formData.pais.id,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.pais.id) = $event)),
                      class: "w-full p-inputtext-sm p-3",
                      disabled: "true"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[42] || (_cache[42] = _createElementVNode("label", { class: "block mb-1" }, "Código de área", -1)),
                _createVNode(_component_Field, {
                  name: "codigoAreaCel",
                  modelValue: _ctx.formData.codigoAreaCel,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.codigoAreaCel) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Codigo de área",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_36, [
                      _createVNode(_component_ErrorMessage, { name: "codigoAreaCel" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _cache[43] || (_cache[43] = _createElementVNode("label", { class: "block mb-1" }, "Teléfono celular", -1)),
                _createVNode(_component_Field, {
                  name: "telefonoCelular",
                  modelValue: _ctx.formData.telefonoCelular,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Número de celular sin el 15 delante",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_38, [
                      _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _cache[44] || (_cache[44] = _createElementVNode("label", { class: "block mb-1" }, "Instagram (opcional)", -1)),
                _createVNode(_component_Field, {
                  name: "instagram",
                  modelValue: _ctx.formData.instagram,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.instagram) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su instagram (Opcional)",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_41, [
                      _createVNode(_component_ErrorMessage, { name: "instagram" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[45] || (_cache[45] = _createElementVNode("label", { class: "block mb-1" }, "LinkedIn (opcional)", -1)),
                _createVNode(_component_Field, {
                  name: "linkedin",
                  modelValue: _ctx.formData.linkedin,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.linkedin) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su LinkedIn (Opcional)",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_43, [
                      _createVNode(_component_ErrorMessage, { name: "linkedin" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _cache[46] || (_cache[46] = _createElementVNode("label", { class: "block mb-1" }, "Canal de streaming (opcional)", -1)),
                _createVNode(_component_Field, {
                  name: "canalStreaming",
                  modelValue: _ctx.formData.canalStreaming,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.canalStreaming) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Su canal de streaming (Opcional)",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_46, [
                      _createVNode(_component_ErrorMessage, { name: "canalStreaming" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _cache[47] || (_cache[47] = _createElementVNode("label", { class: "block mb-1" }, "¿Alguna vez participó en CAPER Show ?", -1)),
                _createVNode(_component_Field, {
                  name: "participo",
                  modelValue: _ctx.formData.participo,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.participo) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      options: _ctx.opcionesSiNo,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_48, [
                      _createVNode(_component_ErrorMessage, { name: "participo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _cache[48] || (_cache[48] = _createElementVNode("label", { class: "block mb-1" }, "Seleccione el ítem que mejor describa la actividad principal de su Empresa/Organización", -1)),
                _createVNode(_component_Field, {
                  name: "actividadPrincipal",
                  modelValue: _ctx.formData.actividadPrincipal,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.actividadPrincipal) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      options: _ctx.actividades,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_51, [
                      _createVNode(_component_ErrorMessage, { name: "actividadPrincipal" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _cache[49] || (_cache[49] = _createElementVNode("label", { class: "block mb-1" }, "Especifique la actividad", -1)),
                _createVNode(_component_Field, {
                  name: "otraActividad",
                  modelValue: _ctx.formData.otraActividad,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.otraActividad) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Otra actividad",
                      maxlength: "50",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_54, [
                      _createVNode(_component_ErrorMessage, { name: "otraActividad" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 512), [
              [_vShow, _ctx.formData.actividadPrincipal?.id === 'Otros']
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _cache[50] || (_cache[50] = _createElementVNode("label", { class: "block mb-1" }, "Indique en qué área se desempeña dentro de su Empresa / Organización ", -1)),
                _createVNode(_component_Field, {
                  name: "areaDentroDeLaEmpresa",
                  modelValue: _ctx.formData.areaDentroDeLaEmpresa,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.areaDentroDeLaEmpresa) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      options: _ctx.areasEmpresa,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_57, [
                      _createVNode(_component_ErrorMessage, { name: "areaDentroDeLaEmpresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _cache[51] || (_cache[51] = _createElementVNode("label", { class: "block mb-1" }, "Especifique el área", -1)),
                _createVNode(_component_Field, {
                  name: "otraArea",
                  modelValue: _ctx.formData.otraArea,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.otraArea) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Otra área",
                      maxlength: "50",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_60, [
                      _createVNode(_component_ErrorMessage, { name: "otraArea" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 512), [
              [_vShow, _ctx.formData.areaDentroDeLaEmpresa?.id === 'Otra']
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _cache[52] || (_cache[52] = _createElementVNode("label", { class: "block mb-1" }, "Indique cuál es su Cargo/Rol dentro de la Empresa u Organización", -1)),
                _createVNode(_component_Field, {
                  name: "rolCargo",
                  modelValue: _ctx.formData.rolCargo,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.rolCargo) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      panelStyle: { width: '50%' },
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      options: _ctx.rolesCargo,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}])
                    }, {
                      option: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.option.descripcion), 1),
                          _createElementVNode("div", _hoisted_64, _toDisplayString(slotProps.option.detalle), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_65, [
                      _createVNode(_component_ErrorMessage, { name: "rolCargo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _cache[53] || (_cache[53] = _createElementVNode("label", { class: "block mb-1" }, "Especifique el Cargo/Rol", -1)),
                _createVNode(_component_Field, {
                  name: "otroCargo",
                  modelValue: _ctx.formData.otroCargo,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.otroCargo) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Otro cargo",
                      maxlength: "50",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_68, [
                      _createVNode(_component_ErrorMessage, { name: "otroCargo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 512), [
              [_vShow, _ctx.formData.rolCargo?.id === 'Otros']
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _cache[54] || (_cache[54] = _createElementVNode("label", { class: "block mb-1" }, "Especifique su rol en la compra", -1)),
                _createVNode(_component_Field, {
                  name: "rolCompra",
                  modelValue: _ctx.formData.rolCompra,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.rolCompra) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      options: _ctx.rolesCompra,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_71, [
                      _createVNode(_component_ErrorMessage, { name: "rolCompra" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "aggrement",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.terminosCondiciones) = $event)),
                    class: "text-primary focus:ring-0 rounded-sm cursor-pointer"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.formData.terminosCondiciones]
                  ]),
                  _cache[55] || (_cache[55] = _createElementVNode("label", {
                    for: "aggrement",
                    class: "text-gray-600 ml-3 cursor-pointer"
                  }, "Ya leí y estoy de acuerdo con los términos y condiciones", -1))
                ])
              ]),
              _cache[56] || (_cache[56] = _createElementVNode("div", null, [
                _createElementVNode("div", { class: "pb-2 text-justify text-xs max-h-96 px-2" }, [
                  _createElementVNode("p", null, [
                    _createTextVNode("• Dejo constancia que he leído, comprendido y aceptado todos los términos de la presente inscripción."),
                    _createElementVNode("br"),
                    _createTextVNode(" • Asimismo, acepto que CAPER puede utilizar y/o divulgar la información y/o datos aquí consignados (a excepción de DNI / PASAPORTE), así como las imágenes y videos que se tomen en el marco del evento, con el fin de difundirlos entre las empresas Expositoras y/o Sponsors y/o Prensa, para su conocimiento y aplicación pertinente."),
                    _createElementVNode("br"),
                    _createTextVNode(" • Por razones de seguridad, los Visitantes aceptan ser fotografiados / filmados en el acceso así como a presentar sus DNIs físicos al momento de retirar su credencial."),
                    _createElementVNode("br"),
                    _createElementVNode("br")
                  ])
                ])
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("button", {
                type: "submit",
                class: "mt-2 px-4 py-2 bg-transparent border-blue-950 hover:bg-black text-blue-950 font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_77, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_78, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[57] || (_cache[57] = _createTextVNode("REGISTRARME ", -1))
              ], 8, _hoisted_76)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
    ]),
    _createVNode(_component_FullScreenLoader, { visible: _ctx.isSubmitting }, null, 8, ["visible"])
  ], 64))
}